import { jsx as o } from "react/jsx-runtime";
import s from "highcharts";
import a from "highcharts-react-official";
import i from "highcharts/modules/sunburst";
import { useMemo as p } from "react";
i(s);
const m = ({
  data: e,
  title: t = "",
  tooltipFormatter: r,
  style: l
}) => {
  const n = p(() => ({
    credits: {
      enabled: !1
    },
    exporting: {
      enabled: !1
    },
    chart: {
      type: "sunburst",
      backgroundColor: "transparent"
    },
    title: {
      text: t
    },
    tooltip: {
      formatter: r ?? function() {
        return `<span style="color:${this.point.color}">●</span> <b>${this.key}:</b> ${this.y} (${this.percentage.toFixed(1)}%)`;
      }
    },
    series: [{
      type: "sunburst",
      data: e,
      allowDrillToNode: !0,
      cursor: "pointer",
      dataLabels: {
        format: "{point.name}",
        filter: {
          property: "innerArcLength",
          operator: ">",
          value: 16
        }
      },
      levels: [{
        level: 1,
        colorByPoint: !0,
        // @ts-expect-error - Highcharts type definitions are incorrect 
        levelIsConstant: !1,
        dataLabels: {
          filter: {
            property: "outerArcLength",
            operator: ">",
            value: 64
          }
        }
      }, {
        level: 2,
        colorByPoint: !0
      }, {
        level: 3,
        colorVariation: {
          key: "brightness",
          to: -0.5
        }
      }, {
        level: 4,
        colorVariation: {
          key: "brightness",
          to: 0.5
        }
      }]
    }]
  }), [e, t, r]);
  return /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(a, { highcharts: s, options: n, containerProps: {
    style: {
      height: "100%",
      ...l
    }
  } }) });
};
export {
  m as default
};
